import React from 'react';
import { Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import './ConsultaImoveis.css';

var PainelSemQuadra = ({ ativos, onInativar }) => {
  if (!ativos || ativos.length === 0) return null;

  var handleInativar = (ativo) => {
    var confirma = window.confirm(
      `Deseja inativar o imóvel ${ativo.codigo_ativo} - ${ativo.nome}?`
    );
    if (!confirma) return;

    api.consultaImoveisInativarAtivo({ codigo_ativo: ativo.codigo_ativo })
      .then(() => {
        toast.success('Imóvel inativado com sucesso.');
        onInativar && onInativar();
      })
      .catch((err) => {
        var msg = err && err.message ? err.message : 'Erro ao inativar imóvel';
        toast.error(msg);
      });
  };

  return (
    <div className="painel-sem-quadra">
      <Alert variant="warning" className="mb-0 py-2">
        <strong>Ativos sem Quadra/Lote:</strong>{' '}
        {ativos.map((ativo) => (
          <span
            key={ativo.codigo_ativo}
            className="ativo-sem-quadra-label"
            onClick={() => handleInativar(ativo)}
            title="Clique para inativar"
          >
            {ativo.codigo_ativo} - {ativo.nome}
          </span>
        ))}
      </Alert>
    </div>
  );
};

export default PainelSemQuadra;
